module.exports = __webpack_public_path__ + "img/61_5.3127efbb.png";